// import React, { useEffect, useState } from 'react';
// import { Modal, Button, Typography, Spin, Image, Space } from 'antd';
// import axios from 'axios';
// import { ArrowLeftOutlined } from '@ant-design/icons';
// import { useNavigate } from 'react-router-dom';

// const InternationalWebPage = () => {
//   const [route, setRoute] = useState();
//   const navigate = useNavigate();
//   useEffect(() => {
//   const storedRoute = sessionStorage.getItem('route');
//   if (storedRoute) {
//     setRoute(storedRoute);        // Your own route-handling state
// // Your custom function
//   }
// }, []);

//   const [internationalData, setInternationalData] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [isModalVisible, setIsModalVisible] = useState(false);
//   const [selectedLanguage, setSelectedLanguage] = useState('en');

//   const languages = [
//     { code: 'en', label: 'English' },
//     { code: 'hi', label: 'हिन्दी' },
//     { code: 'ta', label: 'தமிழ்' },
//     { code: 'te', label: 'తెలుగు' },
//     { code: 'mr', label: 'मराठी' },
//     { code: 'kn', label: 'ಕನ್ನಡ' },
//     { code: 'gu', label: 'ગુજરાતી' },
//     { code: 'bn', label: 'বাংলা' }
//   ];

//   const fetchData = async () => {
//     setLoading(true);
//     try {
//       const res = await axios.post('https://lionsdirectoryapi.emedha.in/international/get', {
//         route
//       });
//       console.log(route)
//       setInternationalData(res.data);
//       console.log(res.data)
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchData();
//   }, [route]);

//   return (
//     <div style={previewContainerStyle} id="preview-box">
//      <div style={{
//       backgroundColor: '#fff',
//       padding: '15px',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'space-between'
//     }}>
//       <div style={{ display: 'flex', alignItems: 'center' }}>
//         <ArrowLeftOutlined
//           style={{
//             fontSize: '18px',
//             color: '#0e3972',
//             cursor: 'pointer',
//             marginRight: '10px'
//           }}
//           onClick={() => navigate('/home')} // or the correct route for HomeScreen
//         />
//         <h6 style={{ color: '#0e3972', fontWeight: 'bold', margin: 0 }}>{route}</h6>
//       </div>
//     </div>

//       <Spin spinning={loading} style={{ flex: 1 }}>
//         <div style={{ overflowY: 'auto', padding: '10px',  }}>
//           {internationalData.map((intl) => (
//             <div
//               key={intl.id}
//               style={{
//                 marginBottom: '10px',
//                 backgroundColor: 'rgb(234, 237, 240)',
//                 borderRadius: '10px',
//                 padding: '10px',
//                 boxShadow: '0 2px 5px rgba(0,0,0,0.1)'
//               }}
//             >
//               <div style={{ textAlign: 'center' }}>
//                 <Image
//                   src={intl.photo || 'https://via.placeholder.com/100'}
//                   width={100}
//                   height={100}
//                   style={{ borderRadius: '50%', border: '2px solid #ccc' }}
//                 />
//               </div>
//               <div style={{ backgroundColor: 'white', borderRadius: '4px', padding: '10px' }}>
//                 <Typography.Text style={{ fontSize: 15 }}>{intl.name}</Typography.Text><br />
//                 <Typography.Text style={{ fontSize: 15 }}>{intl.position}</Typography.Text><br />
//                 <Typography.Text style={{ fontSize: 15 }}>{intl.description}</Typography.Text><br />
//                 <a href={`tel:${intl.mobile}`} style={{ color: '#297af5' }}>{intl.mobile}</a>
//               </div>
//             </div>
//           ))}
//         </div>
//       </Spin>

//       <Modal
//         open={isModalVisible}
//         footer={null}
//         closable={true}
//         onCancel={() => setIsModalVisible(false)}
//         width={300}
//         getContainer={() => document.getElementById("preview-box")}
//         style={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           transform: 'translate(-50%, -50%)'
//         }}
//         mask={false}
//         bodyStyle={{ backgroundColor: '#fff', padding: 10, borderRadius: 10 }}
//       >
//         {languages.map((lang) => (
//           <Button
//             key={lang.code}
//             block
//             style={{
//               marginBottom: 8,
//               backgroundColor: '#06549c',
//               color: '#FFD700',
//               borderColor: '#06549c',
//               fontWeight: 'bold',
//               borderRadius: '6px'
//             }}
//             onClick={() => {
//               setSelectedLanguage(lang.code);
//               setIsModalVisible(false);
//             }}
//           >
//             {lang.label}
//           </Button>
//         ))}
//       </Modal>
//     </div>
//   );
// };

// const previewContainerStyle = {
//   width: '365px',
//   minHeight: '557px',
//   maxHeight: '667px',
//   margin: '10px auto',
//   border: '1px solid #ccc',
//   borderRadius: '20px',
//   overflowY: 'auto',
//   boxShadow: '0 0 10px rgba(0,0,0,0.2)',
//   backgroundColor: '#f8f9fa',
//   display: 'flex',
//   flexDirection: 'column',
//   justifyContent: 'space-between'
// };

// export default InternationalWebPage;

import React, { useEffect, useState } from "react";
import axios from "axios";
import "./international.css";

const InternationaltList = ({ onBack, onSelectItem }) => {
  const [districtCategories, setDistrictCategories] = useState([]);

  useEffect(() => {
    fetchDistrictMenu();
  }, []);

  const fetchDistrictMenu = async () => {
    try {
      const res = await axios.post(
        "https://lionsdirectoryapi.emedha.in/international/menu/get"
      );
      setDistrictCategories(res.data);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <div className="container">
      {/* Header */}
      <div className="header">
        <div className="header-left">
          <button className="back-btn" onClick={onBack}>←</button>
          <h3>International</h3>
        </div>
      </div>

      {/* Categories */}
      <div className="content">
        {districtCategories.map((item, index) => (
          <div
            key={index}
            className="category-card"
            onClick={() => onSelectItem(item.name)}
          >
            <span>{item.name}</span>
            <span>→</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InternationaltList;